import { AUDIT_ACTIONS } from 'shared/fixtures';
import { FormLayout } from 'views/components';
import { HEADERS } from './config';
import { RightCol } from './styled';
import { patientActions } from 'core/Patient';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    Col,
    Row
} from 'reactstrap';
import {
    DateRangePicker,
    DownloadModal,
    ExpandButton,
    FormGroup,
    Loader,
    PageController,
    SelectSearch,
    Table
} from 'mol-ui';
import React, { useEffect, useState } from 'react';
import {
    useDispatch,
    useSelector,
    useToggle
} from 'hooks';

const PatientAudit = () => {

    const dispatch = useDispatch();
    const { id } = useParams();
    const { t } = useTranslation();

    const {
        audit,
        auditDownload,
        auditDownloading,
        loading
    } = useSelector('patient');

    const [action, setAction] = useState(null);
    const [downloadModal, toggleDownloadModal] = useToggle(false);
    const [filters, setFilters] = useState({});

    useEffect(() => {
        const data = {
            ...filters,
            patient_id: Number(id)
        };
        dispatch(patientActions.getPatientAudit(data));
    }, [filters]);

    const handleActionChange = action => {
        const parsedAction = !!action ? action : null;
        setAction(parsedAction);
        setFilters(filters => ({ ...filters, action }));
    };

    const handleDateChange = (start, end) => {
        const newFilters = {
            end_date: end,
            start_date: start
        };
        setFilters(filters => ({ ...filters, ...newFilters }));
    };

    const completeFilters = {
        ...filters,
        patient_id: Number(id)
    };

    const { data } = audit ? audit.getData() : {};

    return (
        <FormLayout
            goBackTo={ `${ t('/pacientes/historial') }/${ id }` }
            title={ t('Auditoría') }
        >
            <DownloadModal
                active={ downloadModal }
                data={ auditDownload }
                fileName={ t('Auditoría') }
                headers={ HEADERS }
                loading={ auditDownloading }
                onFetchData={ () => dispatch(patientActions.getPatientAuditDownload(completeFilters)) }
                onToggle={ toggleDownloadModal }
            />
            <Row>
                <Col md="6" xs="12">
                    <FormGroup label={ t('Acción') } margin="0px 0px 20px 0px">
                        <SelectSearch
                            allowNone
                            options={ AUDIT_ACTIONS }
                            placeholder={ t('Todas las acciones') }
                            value={ action }
                            width="100%"
                            onChange={ handleActionChange }
                        />
                    </FormGroup>
                </Col>
                <RightCol md="6" xs="12">
                    <FormGroup label={ t('Fecha') } margin="0px 0px 20px 0px">
                        <DateRangePicker
                            allowFutureDays={ false }
                            position="right"
                            onChange={ handleDateChange }
                        />
                    </FormGroup>
                </RightCol>
            </Row>
            <Row>
                <RightCol>
                    <ExpandButton
                        caption={ t('Descargar') }
                        icon="download"
                        margin="0px 0px 10px 0px"
                        size={ 80 }
                        width={ 120 }
                        onClick={ toggleDownloadModal }
                    />
                </RightCol>
            </Row>
            <Table
                config={ HEADERS }
                data={ data }
                margin="0px"
                maxHeight="500px"
            />
            {
                loading
                    ? <Loader active />
                    : <PageController
                        controller={ audit }
                        height="50px"
                    />
            }
        </FormLayout>
    );
};

export default PatientAudit;
